import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, useMatches } from '@tanstack/react-router'

import '../index.css'
import React from 'react'
import { Helmet } from 'react-helmet-async'

import { Api } from '@/api/api'
import { useI18n } from '@/i18n/i18n-react'
import { Translations } from '@/i18n/i18n-types'

export interface RouterContextType {
	queryClient: QueryClient
	api: Api
	L: Translations
}

const TanStackRouterDevtools =
	process.env.NODE_ENV === 'production'
		? () => null // Render nothing in production
		: React.lazy(() =>
				// Lazy load in development
				import('@tanstack/router-devtools').then(res => ({
					default: res.TanStackRouterDevtools
					// For Embedded Mode
					// default: res.TanStackRouterDevtoolsPanel
				}))
			)

const PageTitle = () => {
	const { L } = useI18n()
	const matches = useMatches()
	// Walk from the deepest match upward, using the first crumb that resolves to
	// a truthy value. A route can have a crumb function but no data yet (e.g. its
	// loader hasn't resolved), in which case we fall back to a shallower crumb
	// instead of the generic default title.
	let crumb: string | undefined
	for (const match of [...matches].reverse()) {
		if (!match.staticData?.crumb) {
			continue
		}
		const value = match.staticData.crumb(match as any)
		if (value) {
			crumb = value
			break
		}
	}
	const title = crumb ? `${crumb} | ${L.General.AppName()}` : L.General.DefaultPageTitle()
	return (
		<Helmet>
			<title>{title}</title>
		</Helmet>
	)
}

export const Route = createRootRouteWithContext<RouterContextType>()({
	component: () => (
		<>
			<PageTitle />
			<Outlet />
			{/* <Suspense>
				<TanStackRouterDevtools />
			</Suspense> */}
		</>
	)
})
